import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const OneConfiguartionBasicInfoComponent = ({ chosenOneConfigurations, handleInnerFormChange }: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Programs Menu"
              name="ShowProgramsMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'HeaderConfigurations.ShowProgramsMenu',
                  chosenOneConfigurations?.HeaderConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.HeaderConfigurations?.ShowProgramsMenu}
            />

            <InputContainer
              label="Show Communities Menu"
              name="ShowCommunitiesMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'HeaderConfigurations.ShowCommunitiesMenu',
                  chosenOneConfigurations?.HeaderConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.HeaderConfigurations?.ShowCommunitiesMenu}
            />
            <InputContainer
              label="Show Events Menu"
              name="ShowEventsMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'HeaderConfigurations.ShowEventsMenu',
                  chosenOneConfigurations?.HeaderConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.HeaderConfigurations?.ShowEventsMenu}
            />
            <InputContainer
              label="Show Support Menu"
              name="ShowSupportMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'HeaderConfigurations.ShowSupportMenu',
                  chosenOneConfigurations?.HeaderConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.HeaderConfigurations?.ShowSupportMenu}
            />
          </div>
        }
        expandedPanel="HeaderConfigurations"
        headerTitle="HeaderConfigurations"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Ventures Menu In Header"
              name="ShowVenturesMenuInHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'VenturesMenuConfigurations.ShowVenturesMenuInHeader',
                  chosenOneConfigurations?.VenturesMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.VenturesMenuConfigurations?.ShowVenturesMenuInHeader}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VenturesMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.VenturesMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.VenturesMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VenturesMenuConfigurations.MenuName',
                  chosenOneConfigurations?.VenturesMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.VenturesMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="VenturesMenuConfigurations"
        headerTitle="VenturesMenuConfigurations"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Agencies Menu In Header"
              name="ShowAgenciesMenuInHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'AgenciesMenuConfigurations.ShowAgenciesMenuInHeader',
                  chosenOneConfigurations?.AgenciesMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.AgenciesMenuConfigurations?.ShowAgenciesMenuInHeader}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AgenciesMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.AgenciesMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.AgenciesMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AgenciesMenuConfigurations.MenuName',
                  chosenOneConfigurations?.AgenciesMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.AgenciesMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="AgenciesMenuConfigurations"
        headerTitle="AgenciesMenuConfigurations"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Partner Menu In Header"
              name="ShowPartnerMenuInHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'PartnerMenuConfigurations.ShowPartnerMenuInHeader',
                  chosenOneConfigurations?.PartnerMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.PartnerMenuConfigurations?.ShowPartnerMenuInHeader}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PartnerMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.PartnerMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.PartnerMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PartnerMenuConfigurations.MenuName',
                  chosenOneConfigurations?.PartnerMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.PartnerMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="PartnerMenuConfigurations"
        headerTitle="PartnerMenuConfigurations"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Marketplace Menu In Header"
              name="ShowMarketplaceMenuInHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'MarketplaceMenuConfigurations.ShowMarketplaceMenuInHeader',
                  chosenOneConfigurations?.MarketplaceMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.MarketplaceMenuConfigurations?.ShowMarketplaceMenuInHeader}
            />

            <InputContainer
              label="Marketplace Url"
              name="MarketplaceUrl"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MarketplaceMenuConfigurations.MarketplaceUrl',
                  chosenOneConfigurations?.MarketplaceMenuConfigurations

                )
              }}
              type="text"
              value={chosenOneConfigurations?.MarketplaceMenuConfigurations?.MarketplaceUrl}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MarketplaceMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.MarketplaceMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.MarketplaceMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MarketplaceMenuConfigurations.MenuName',
                  chosenOneConfigurations?.MarketplaceMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.MarketplaceMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="MarketplaceMenuConfigurations"
        headerTitle="MarketplaceMenuConfigurations"
      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Catalyst Menu"
              name="ShowCatalystMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'CatalystMenuConfigurations.ShowCatalystMenu',
                  chosenOneConfigurations?.CatalystMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.ShowCatalystMenu}
            />



            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CatalystMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.CatalystMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CatalystMenuConfigurations.MenuName',
                  chosenOneConfigurations?.CatalystMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.MenuName}
            />

          </div>
        }


        expandedPanel="CatalystMenuConfigurations"
        headerTitle="CatalystMenuConfigurations"


      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Mentor Menu"
              name="ShowMentorMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'MentorMenuConfigurations.ShowMentorMenu',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.ShowMentorMenu}
            />



            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MentorMenuConfigurations.MenuName',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.MenuName}
            />

          </div>
        }


        expandedPanel="MentorMenuConfigurations"
        headerTitle="MentorMenuConfigurations"


      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Trainer Menu"
              name="ShowTrainerMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'TrainerMenuConfigurations.ShowTrainerMenu',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.ShowTrainerMenu}
            />



            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TrainerMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TrainerMenuConfigurations.MenuName',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.MenuName}
            />

          </div>
        }


        expandedPanel="TrainerMenuConfigurations"
        headerTitle="TrainerMenuConfigurations"


      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Corporate Menu"
              name="ShowCorporateMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'CorporateMenuConfigurations.ShowCorporateMenu',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.ShowCorporateMenu}
            />



            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CorporateMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CorporateMenuConfigurations.MenuName',
                  chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.MenuName}
            />

          </div>
        }


        expandedPanel="CorporateMenuConfigurations"
        headerTitle="CorporateMenuConfigurations"


      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Cloud Page Menu"
              name="ShowCloudPageMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'CloudPageMenuConfigurations.ShowCloudPageMenu',
                  chosenOneConfigurations?.CloudPageMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.CloudPageMenuConfigurations?.ShowCloudPageMenu}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CloudPageMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.CloudPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CloudPageMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'CloudPageMenuConfigurations.MenuName',
                  chosenOneConfigurations?.CloudPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.CloudPageMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="CloudPageMenuConfigurations"
        headerTitle="CloudPageMenuConfigurations"
      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Framework Page Menu"
              name="ShowFrameworkPageMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'FrameworkPageMenuConfigurations.ShowFrameworkPageMenu',
                  chosenOneConfigurations?.FrameworkPageMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.FrameworkPageMenuConfigurations?.ShowFrameworkPageMenu}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FrameworkPageMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.FrameworkPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.FrameworkPageMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'FrameworkPageMenuConfigurations.MenuName',
                  chosenOneConfigurations?.FrameworkPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.FrameworkPageMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="FrameworkPageMenuConfigurations"
        headerTitle="FrameworkPageMenuConfigurations"
      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Network Page Menu"
              name="ShowNetworkPageMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'NetworkPageMenuConfigurations.ShowNetworkPageMenu',
                  chosenOneConfigurations?.NetworkPageMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.NetworkPageMenuConfigurations?.ShowNetworkPageMenu}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NetworkPageMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.NetworkPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.NetworkPageMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NetworkPageMenuConfigurations.MenuName',
                  chosenOneConfigurations?.NetworkPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.NetworkPageMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="NetworkPageMenuConfigurations"
        headerTitle="NetworkPageMenuConfigurations"
      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Testimonial Page Menu"
              name="ShowTestimonialPageMenu"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'TestimonialPageMenuConfigurations.ShowTestimonialPageMenu',
                  chosenOneConfigurations?.TestimonialPageMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.TestimonialPageMenuConfigurations?.ShowTestimonialPageMenu}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TestimonialPageMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.TestimonialPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.TestimonialPageMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TestimonialPageMenuConfigurations.MenuName',
                  chosenOneConfigurations?.TestimonialPageMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.TestimonialPageMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="TestimonialPageMenuConfigurations"
        headerTitle="TestimonialPageMenuConfigurations"
      />

      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


            <InputContainer
              label="Show Membership Menu In Header"
              name="ShowMembershipMenuInHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'MembershipMenuConfigurations.ShowMembershipMenuInHeader',
                  chosenOneConfigurations?.MembershipMenuConfigurations
                )
              }}
              type="checkbox"
              value={chosenOneConfigurations?.MembershipMenuConfigurations?.ShowMembershipMenuInHeader}
            />

            <InputContainer
              label="Fav Icon"
              labelField="FavIcon"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipMenuConfigurations.FavIcon',
                  chosenOneConfigurations?.MembershipMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.MembershipMenuConfigurations?.FavIcon}
            />
            <InputContainer
              label="Menu Name"
              labelField="MenuName"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MembershipMenuConfigurations.MenuName',
                  chosenOneConfigurations?.MembershipMenuConfigurations,
                );
              }}
              type="text"
              value={chosenOneConfigurations?.MembershipMenuConfigurations?.MenuName}
            />

          </div>
        }
        expandedPanel="MembershipMenuConfigurations"
        headerTitle="MembershipMenuConfigurations"
      />
    </>
  )
}
export default OneConfiguartionBasicInfoComponent;
